<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn fab :small="$vuetify.breakpoint.smAndDown" :large="$vuetify.breakpoint.mdAndUp" depressed class="mx-3"
            :light="!publisherAudio"
            :color="!publisherAudio ? 'white' : 'rgba(255,255,255, 0.2)'"
            @click="togglePublisherAudio"
            :disabled="!isConnected"
            v-bind="attrs"
            v-on="on"
            >
            <v-icon>{{ !publisherAudio ? 'mdi-microphone-off' : 'mdi-microphone' }}</v-icon>
            </v-btn>
        </template>
        <span>{{ !publisherAudio ? 'Unmute microphone' : 'Mute microphone' }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'MuteButton',
    props: ['isConnected', 'publisherAudio'],
    data: () => ({

    }),
    methods: {
        togglePublisherAudio () {
            this.$emit('togglePublisherAudio');
        }
    }
}
</script>
